import React from "react";
import {
  Route,
  Switch,
  withRouter,
} from "react-router-dom";
import Header from "../Header";
import Dashboard from "../../pages/dashboard";
import Sidebar from "../Sidebar";
import DatePicker from "../../pages/Lead/components/DatePicker/DatePicker";
import User from "../../pages/User/User";
import moreDetails from "../../pages/Lead/moreDetails";
import Category from "../../pages/Category/Category";
import DeactiveReminder from "../../pages/Reminder/DeactiveReminder";
import Lead from "../../pages/Lead/Lead";
import ActiveReminder from "../../pages/Reminder/ActiveReminder";
import ChangePassword from "../../pages/ChangePassword";


function Layout(props) {
  return (
    <div >
      <>
        <div className="overflow-hidden">
          <div className="bg-gray-100 ">
            <div className="flex flex-col justify-center min-h-screen">
              <div className="flex h-screen overflow-hidden" >
                <Sidebar />
                <div className="flex flex-col flex-1 w-0 overflow-hidden">
                  <Header history={props.history} />
                  <Switch>
                    <Route path="/app/dashboard" component={withRouter(Dashboard)} />
                    <Route path="/app/datePicker" component={withRouter(DatePicker)} />
                    <Route path="/app/:status/Lead/:pageNo?/:keyWord?" component={withRouter(Lead)} />
                    <Route path="/app/active/reminder" component={withRouter(ActiveReminder)} />
                    <Route path="/app/deactive/reminder" component={withRouter(DeactiveReminder)} />
                    <Route path="/app/user" component={withRouter(User)} />
                    <Route path="/app/changepassword" component={withRouter(ChangePassword)} />
                    <Route path="/app/category" component={withRouter(Category)} />
                    <Route path="/app/moreDetails/:id" component={withRouter(moreDetails)} />
                  </Switch>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    </div>
  );
}

export default withRouter(Layout);
